import { render, staticRenderFns } from "./CanvasBox.vue?vue&type=template&id=0639183c&"
import script from "./CanvasBox.vue?vue&type=script&lang=js&"
export * from "./CanvasBox.vue?vue&type=script&lang=js&"
import style0 from "./CanvasBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports